import { PaymentErrorPathsEnum } from '@src/domains/payments/types/payment';

const CARD_PREFIX = `${PaymentErrorPathsEnum.PAYMENT_CARD}.`;

// Maps a 422 validation key onto the path it refers to inside `PaymentCardParams`.
export const parsePaymentErrorPath = (key: string): string | null => {
  if (key === PaymentErrorPathsEnum.PAYMENT_CARD) {
    return '';
  }

  if (key.startsWith(CARD_PREFIX)) {
    return key.slice(CARD_PREFIX.length);
  }

  return null;
};
